
const TabButton = ({on, off, active, line, onClick}) => {
    return (
        <button className={`flex flex-col gap-1.5 justify-center items-center self-stretch my-auto`}
                onClick={onClick}>
            <img loading="lazy"
                 src={active ? on : off}
                 alt=""
                 className="flex object-contain shrink-0 self-stretch my-auto "
                 draggable="false" // 드래그 방지
            />
            {/* active일 때만 라인 표시 */}
            {active && (
                <div
                    className="flex z-10 shrink-0 -mt-2.5 h-0.5 bg-blue-500"
                    style={{ width: `${line}px` }} // 인라인 스타일로 동적 길이 설정
                />
            )}
        </button>
    );
}

export default TabButton;